@if (
  {
    row: columnData() | async,
  };
  as $
) {
  @if ($.row && $.row.opp_lost_reason_type) {
    <span
      >{{
        'OPPORTUNITY.LOSTDEAL.' + getLostReasonType($.row.opp_lost_reason_type)
          | translate
      }}
    </span>
  }
}
